import React from "react";
import { formatCurrency } from "../../lib/common";
import { AttributeOption, AttributePriceType } from "./types";

export const PriceDisplay: React.FC<{
  opt: AttributeOption;
  displayZero: string;
  wrap?: (content: React.ReactNode) => JSX.Element;
}> = ({ opt, displayZero, wrap }) => {
  let display: React.ReactNode = null;

  if (opt.PriceType === AttributePriceType.Override) {
    display = formatCurrency(opt.Price);
  } else if (opt.PriceType === AttributePriceType.Same) {
    display = displayZero;
  } else if (opt.Price === 0) {
    display = displayZero;
  } else if (opt.PriceType === AttributePriceType.Add) {
    display = `+ ${formatCurrency(opt.Price)}`;
  } else if (opt.PriceType === AttributePriceType.Subtract) {
    display = `- ${formatCurrency(opt.Price)}`;
  }

  if (!display) return <></>;

  return <>{wrap ? wrap(display) : display}</>;
};
